<template lang="pug">
   .change-color-cta.row.xs-mt-100m
    .xs-f-small.lg-f-small.max-at-tweak(v-if="sameProductInSub" :class="{ 'hide-in-sticky': subscription.id }")
      p.xs-12.text-center This is your current {{ changeText }}
      p.xs-12.text-center.xs-pb-100m Next shipment:
        span.bold.xs-pl-50m {{ $formatDate(subscription.next, "MMMM DD") }}

    button.mr-btn.xs-f-xsmall.max-at-tweak.xs-12.xs-mb-100m(
      type="button"
      @click="changeSubColor"
      :class="{ 'hide-in-sticky disabled': sameProductInSub }"
    ) Change your {{ changeText }}

    .xs-12.text-center.xs-mb-200m(v-if="!sameProductInSub && myColorUrl" :class="{ 'hide-in-sticky': subscription.id }")
      router-link.current-color.underline.upper.xs-f-xsmall.max-at-tweak.f-primary.bold.xs-pt-100m.xs-pb-100m(:to="myColorUrl") View your current {{ changeText }}
</template>

<script>

  import {mapState, mapActions, mapGetters} from 'vuex';

  export default {


    name: 'ChangeColorCTA',

    inject: ['getObjProperty'],

    computed: {
      ...mapState('pdp', [
        'version',
        'product',
        'purchaseType',
        'qty',
        'skipPurchasePanel',
        'preOrderId',
        'subscription',
        'addPerfectPair',
        'perfectPairSubPrice'
      ]),

      ...mapGetters('pdp', [
        'changeText'
      ]),

      sameProductInSub() {
        let subedProdId = this.getObjProperty(this.subscription, 'product.id');
        return this.product.id == subedProdId;
      },

      myColorUrl() {
        let url = null;
        let urlKey = this.getObjProperty(this.subscription, 'product.url_key');

        if (urlKey) {
          url = `/product/${urlKey}`;
        }

        return url;
      },

    },

    methods: {
      ...mapActions('modal', ['showModal']),

      changeSubColor() {
        this.showModal({
          component: 'PdpChangeColorModal',
          props: {}
        });
      },
    },

  };
</script>

<style lang="stylus">
  @media mq-desktop-plus
    .change-color-cta
      width 100%
</style>